import { type InputHTMLAttributes, type ReactNode } from 'react';

export interface FormCheckProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: ReactNode;
  /** checkbox (default), radio, or switch. */
  type?: 'checkbox' | 'radio' | 'switch';
  /** Lay out inline with siblings. */
  inline?: boolean;
  /** Reverse: label first, control on the right. */
  reverse?: boolean;
}

/** Limitless form check — `<label class="form-check"><input/><span/></label>`. */
export function FormCheck({
  label,
  type = 'checkbox',
  inline = false,
  reverse = false,
  className = '',
  ...rest
}: FormCheckProps) {
  const wrapper = [
    'form-check',
    type === 'switch' ? 'form-switch' : '',
    inline ? 'form-check-inline' : '',
    reverse ? 'form-check-reverse' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <label className={wrapper}>
      <input type={type === 'radio' ? 'radio' : 'checkbox'} className="form-check-input" {...rest} />
      <span className="form-check-label">{label}</span>
    </label>
  );
}

export const Checkbox = (props: Omit<FormCheckProps, 'type'>) => <FormCheck {...props} type="checkbox" />;
export const Radio = (props: Omit<FormCheckProps, 'type'>) => <FormCheck {...props} type="radio" />;
export const Switch = (props: Omit<FormCheckProps, 'type'>) => <FormCheck {...props} type="switch" />;
